import { Injectable } from '@angular/core'
import { environment } from '../../../../../environments/environment'
import { HttpClient } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../../models/response.model'
import {
  CreateDocumentTypeModel,
  DeleteDocumentTypeModel,
  SearchDocumentTypeModel,
} from '../../../models/document-type.model'

@Injectable({
  providedIn: 'root',
})
export class DocumentTypeService {
  private baseUrl = environment.baseUrl
  private resourceType = 'TipoDocumento'

  constructor(private httpClient: HttpClient) {}

  public createDocumentType(
    model: CreateDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/create`,
      model,
    )
  }

  public editDocumentType(
    model: any,
    // model: EditDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/edit`,
      model,
    )
  }

  public deleteDocumentType(
    model: DeleteDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/delete`,
      model,
    )
  }

  public listPagedDocumentType(
    page: number,
    rows = 15,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listDocumentType(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/listall`,
    )
  }

  public getDocumentTypebyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/${id}`,
    )
  }

  public searchPagedDocumentType(
    page: number,
    rows = 15,
    model: SearchDocumentTypeModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resourceType}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }
}
